<div class="app-body login-background-Image">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"><strong> Loading... </strong></p>
  </ngx-spinner>
  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row">

        <div class="col-md-8 mx-auto">
          <div class="row" style="margin-bottom: 50px">

           

          </div>

          <div class="card-group">
            <div class="card p-4">

              <div class="card-body">

                <form [formGroup]="form">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-user"></i></span>
                    </div>
                    <input type="text" class="form-control" placeholder="Username" formControlName="username"
                    [ngClass]="{'is-invalid':submitted && f.username.errors}">
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                      <div *ngIf="f.username.errors.required">Username is required</div>
                    </div>
                  </div>
                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input type="password" class="form-control" placeholder="Password" autocomplete="off"  formControlName="password"
                    [ngClass]="{'is-invalid':submitted && f.password.errors}" autocomplete="off">
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                      <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">

                    </div>
                    <div class="col-6 text-right">
                      <button type="submit" class="btn btn-primary px-4" (click)="onSubmit()">Login</button>

                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>